export interface CreditReportingAgency {
  creditReportingAgencyId?: string;
  creditReportingAgencyName?: string;
  creditReportingCompany?: CreditReportingCompany;
  isActive: boolean;
  duIdentifier?: string;
  lpaIdentifier?: string;
  meridianLinkBaseUrl?: string;
  updatedDate?: Date | string;
  updatedBy?: string;
}
export interface CreditReportingAgencyBasicView {
  creditReportingAgencyId?: string;
  creditReportingAgencyName?: string;
  creditReportingCompany?: CreditReportingCompany;
}

export enum CreditReportingCompany {
  Xactus = 'Xactus',
  InformativeResearch = 'Informative Research',
  FactualData = 'Factual Data',
  MeridianLink = 'MeridianLink',
}
